<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <v-img
          alt="Tsinghua Logo"
          class="shrink"
          contain
          src="./assets/thu-logo.png"
          transition="scale-transition"
          width="55"
        />
      </div>

      <v-spacer></v-spacer>

      <v-toolbar-title>
        <span>iMoon-Lab Visual Object Retrieval System</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn href="https://www.moon-lab.tech/" target="_blank" text>
        <span class="mr-2">Lab</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <VORS />
    </v-main>
    <v-footer color="primary" dark padless>
      <v-container fluid class="pa-0">
        <v-row class="align-center" no-gutters>
          <v-col cols="12" md="10">
            <v-card-subtitle class="text-center pb-1 text-subtitle-1">
              <strong>iMoon: Intelligent Media and Cognition Lab</strong>
            </v-card-subtitle>
            <v-card-text class="text-center">
               Yue Gao and Yifan Feng. Copyright © 2022 - {{ new Date().getFullYear() }}, All rights
              reserved.
            </v-card-text>
          </v-col>
          <v-col cols="12" md="2" class="d-flex justify-center">
            <v-btn v-for="item in icons" :key="item.idx" class="mx-4" :href="item.link" icon>
              <v-icon size="24px">
                {{ item.icon }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import VORS from "./components/VORS";

export default {
  name: "App",

  components: {
    VORS,
  },

  data: () => ({
    icons: [
      {
        idx: 0,
        icon: "mdi-home",
        link: "https://www.moon-lab.tech/",
      },
      {
        idx: 1,
        icon: "mdi-email",
        link: "mailto:evanfeng97@qq.com",
      },
      {
        idx: 2,
        icon: "mdi-source-repository",
        link: "https://github.com/iMoonLab",
      },
      {
        idx: 3,
        icon: "mdi-github",
        link: "https://github.com/yifanfeng97/OS-MN40-Example",
      },
    ]
  }),
};
</script>
